import {
  defaultBaseQuery,
  transformErrorResponse,
  transformSuccessResponse,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const attendanceAPI = createApi({
  reducerPath: "attendanceAPI",
  baseQuery: defaultBaseQuery,
  tagTypes: ["AttendanceHistory"],
  endpoints: (builder) => ({
    getAttendanceHistory: builder.query({
      query: ({ fromDate, toDate, page = 0, size = 10 }) => ({
        url: `/attendance/history`,
        method: "GET",
        params: { fromDate, toDate, page, size },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["AttendanceHistory"],
    }),
    exportAttendanceExcel: builder.query({
      query: ({ fromDate, toDate }) => ({
        url: `/attendance/history/excel`,
        method: "GET",
        params: { fromDate, toDate },
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
    getPunchDetails: builder.query({
      query: ({ fromDate, toDate }) => ({
        url: `/attendance/punch-details`,
        method: "GET",
        params: { fromDate, toDate },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
  }),
});

export const {
  useGetAttendanceHistoryQuery,
  useLazyGetAttendanceHistoryQuery,
  useLazyExportAttendanceExcelQuery,
  useLazyGetPunchDetailsQuery,
} = attendanceAPI;

export default attendanceAPI;
